var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.hidden) ? _c('div', {
    style: (_vm.disabled ? 'position: relative;' : ''),
    attrs: {
      "id": _vm.cid
    }
  }, [(_vm.disabled) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "z-index": "99",
      "cursor": "not-allowed"
    },
    attrs: {
      "id": "coverlayer"
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-291bf895","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dynamic/ConfigurableComponent.vue
// module id = 1525
// module chunks = 1